<template>
  <div class="spiral">

    <PerspectiveCamera
      :fov="75"
      :aspect="size.aspect"
      :near="1"
      :far="1000"
      :position="{ x: 0, y: 0, z: 500 }"
      @camera="(v) => { camera = v; }"
    />

    <Scene @scene="(v) => { scene = v }">

      <!-- <Object3D pz="10">
        <PointLight />
      </Object3D> -->

      <!-- <Object3D pz="0">
        <Points @element="(v) => { v.$skipRayCast = true }">
          <SphereBufferGeometry />
          <ShaderMaterial :vs="simpleVS2" :fs="simpleFS" :uniforms="animatable" />
        </Points>
      </Object3D> -->

      <!-- <Object3D pz="1">
        <Mesh @element="(v) => { v.onClick = onClick }">
          <SphereBufferGeometry />
          <ShaderMaterial :vs="simpleVS" :fs="simpleFS" :uniforms="animatable" />
        </Mesh>
      </Object3D> -->

      <Object3D
        v-if="hasPerf"
        :key="sfi"
        :px="160"
        :pz="-100"
        v-for="(sf, sfi) in fieldSettings"
        @element="(e) => { spiralObject3D[sfi] = e }"
        :sx="sf.sx" :sy="sf.sy" :sz="sf.sz"
      >
        <Object3D
          o-py="-200"
          :py="-350"
          :pz="-300 / 2"
        >
          <SpiralField
            @element="(e) => { spiralElements[sfi] = e }"
            :texture="sf.texture"
            :widthSeg="70 * 0.5"
            :heightSeg="50 * 0.5"
            :radius="300"
            :height="2000"
          />
        </Object3D>
      </Object3D>

    </Scene>

  </div>
</template>

<script>
import Bundle from '@/components/ThreeJS/Bundle.js'

import * as StarCloud from '@/components/Parts/StarCloud/StarCloud.js'
import SpiralField from '@/components/Parts/SpiralField/SpiralField.vue'

import simpleVS from '@/components/Shaders/Simple/vs.vert'
import simpleVS2 from '@/components/Shaders/Fling/vs.vert'
import simpleFS from '@/components/Shaders/Simple/fs.frag'
import * as TWEEN from '@tweenjs/tween.js'
import * as THREE from 'three'
import Dual from '@/components/Layouts/Dual.mixin.js'
import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'

/* eslint-disable */
var iOS = parseFloat(
	('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1])
	.replace('undefined', '3_2').replace('_', '.').replace('_', '')
) || false;
/* eslint-enable */
let hasPerf = !iOS || (iOS >= 11)

export default {
  name: 'Spiral',
  mixins: [
    Dual
  ],
  props: {
    toucher: {},
    size: {},
    renderer: {},
    doc: {}
  },
  components: {
    ...Bundle,
    SpiralField
  },
  computed: {
  },
  data () {
    return {
      Math,
      StarCloud,
      fieldSettings: [
        {
          speed: 0.0015,
          texture: StarCloud.getSvg('#8a7194'),

          sx: 1.0,
          sy: 1.0,
          sz: 1.0
        },
        {
          speed: 0.0015,
          texture: StarCloud.getSvg('#e2d9c2'),

          sx: 1.0,
          sy: 1.1,
          sz: 1.0
        },
        {
          speed: 0.0015,
          texture: StarCloud.getSvg('#f2eeca'),

          sx: 1.0,
          sy: 1.2,
          sz: 1.0
        },
        {
          speed: 0.0015,
          texture: StarCloud.getSvg('#081f2c'),

          sx: 1.0,
          sy: 1.3,
          sz: 1.0
        },
        {
          speed: 0.0015,
          texture: StarCloud.getSvg('#8a7194'),

          sx: 1.0,
          sy: 1.4,
          sz: 1.0
        },
        {
          speed: 0.0015,
          texture: StarCloud.getSvg('#8a7194'),

          sx: 1.0,
          sy: 1.5,
          sz: 1.0
        }
      ],
      spiralObject3D: [],
      spiralElements: [],

      cam: {
        pos: { x: 3, y: 5, z: 10 }
      },

      resizer: () => {},

      animatable: {
        time: { value: 0 }
      },
      simpleVS,
      simpleFS,
      simpleVS2,
      hasPerf
    }
  },
  methods: {
    setup () {
      this.scene.background = new THREE.Color(0x060C26)

      // var simlingling = () => {
      //   this.spiralElements.forEach((item, i) => {
      //     item.starsMaterial.uniforms.opacity.value = Math.random()
      //   })
      //   setTimeout(simlingling, 100 * Math.random())
      // }
      // simlingling()
    },
    onClick ({ event, intersects }) {
      console.log(event, intersects)
      this.$router.push('/')
      this.$forceUpdate()
    },
    renderWebGL () {
      if (!ScrollMonitor.state.play) {
        return
      }

      TWEEN.update()

      this.animatable.time.value += 0.01

      if (this.spiralObject3D) {
        this.spiralObject3D.forEach((f, fi) => {
          let speed = this.fieldSettings[fi].speed || 0.001
          let material = this.spiralElements[fi].starsMaterial

          material.uniforms.time.value = window.performance.now() * 0.001
          f.rotation.y += speed

          // if (f.position.y < 800) {
          //   f.position.y += 0.1
          // }
        })
      }

      if (this.scene && this.camera && this.renderer) {
        this.renderer.render(this.scene, this.camera)
      }
    }
  },
  created () {

  },
  activated () {
    var self = this
    function loop (rAFT) {
      self.rAFID = window.requestAnimationFrame(loop)
      self.renderWebGL(rAFT)
    }
    self.rAFID = window.requestAnimationFrame(loop)
  },
  deactivated () {
    window.cancelAnimationFrame(this.rAFID)
    console.log('cancel animation frame')
  }
}
</script>

<style scoped>
/* .full{
  width: 100%;
  height: 100%;
} */
</style>



// WEBPACK FOOTER //
// src/components/Scenes/Spiral/SpiralVase.vue